module.exports = __webpack_public_path__ + "static/media/Financing-offer-used-french.aad0e1ad.png";